<template>
  <div id="app" class="min-h-screen bg-slate-950">
    <!-- 通知组件 -->
    <Notification
      v-if="appStore.notification"
      :notification="appStore.notification"
      @close="appStore.hideNotification"
    />

    <!-- 全局加载指示器 -->
    <div
      v-if="appStore.loading"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 backdrop-blur-sm"
    >
      <div class="max-w-sm rounded-3xl border border-white/10 bg-slate-900 p-6 shadow-2xl">
        <div class="flex items-center space-x-4">
          <div class="h-8 w-8 animate-spin rounded-full border-b-2 border-cyan-300"></div>
          <div class="text-slate-100">{{ appStore.loadingMessage || 'Loading...' }}</div>
        </div>
      </div>
    </div>

    <template v-if="isConsoleRoute">
      <div v-if="configStore.hasValidConfig || route.name === 'Config'" class="flex h-screen bg-slate-100">
        <Sidebar v-if="configStore.hasValidConfig" />

        <div class="flex flex-1 flex-col overflow-hidden">
          <Header v-if="configStore.hasValidConfig" />
          <main
            class="flex-1 overflow-x-hidden overflow-y-auto"
            :class="configStore.hasValidConfig ? 'bg-slate-100 p-6' : 'flex items-center justify-center bg-slate-950 p-6'"
          >
            <router-view />
          </main>
        </div>
      </div>
    </template>

    <template v-else>
      <PublicHeader />
      <main>
        <router-view />
      </main>
      <PublicFooter />
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useConfigStore } from './stores/config';
import { useAppStore } from './stores/app';
import { useI18nStore } from './stores/i18n';
import { useMemberStore } from './stores/member';
import { applySeo } from './utils/seo';
import Header from './components/layout/Header.vue';
import Sidebar from './components/layout/Sidebar.vue';
import Notification from './components/common/Notification.vue';
import PublicHeader from './components/public/PublicHeader.vue';
import PublicFooter from './components/public/PublicFooter.vue';

const route = useRoute();
const configStore = useConfigStore();
const appStore = useAppStore();
const i18n = useI18nStore();
const memberStore = useMemberStore();

const isConsoleRoute = computed(() => route.meta.layout === 'console');

onMounted(() => {
  configStore.loadConfig();
  memberStore.hydrate();
  i18n.setLocale(i18n.locale);
});

watchEffect(() => {
  applySeo(route, i18n.locale);
});
</script>

<style>
/* 全局样式已在 main.css 中定义 */
</style>
